(() => {
  const DURATION = 300;
  const EASING = 'ease';
  const states = new WeakMap();

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getState = (details) => {
    let state = states.get(details);
    if (!state) {
      state = { animation: null, isClosing: false, isExpanding: false };
      states.set(details, state);
    }
    return state;
  };

  const onFinish = (details, state, open) => {
    details.open = open;
    details.style.height = '';
    details.style.overflow = '';
    state.animation = null;
    state.isClosing = false;
    state.isExpanding = false;
  };

  const expand = (details, state) => {
    state.isExpanding = true;
    const startHeight = `${details.offsetHeight}px`;
    details.style.height = 'auto';
    const endHeight = `${details.offsetHeight}px`;
    details.style.height = startHeight;

    state.animation?.cancel();
    state.animation = details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: EASING });
    state.animation.onfinish = () => onFinish(details, state, true);
    state.animation.oncancel = () => (state.isExpanding = false);
  };

  const open = (details, state) => {
    details.style.height = `${details.offsetHeight}px`;
    details.open = true;
    window.requestAnimationFrame(() => expand(details, state));
  };

  const close = (details, summary, state) => {
    state.isClosing = true;
    const startHeight = `${details.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    state.animation?.cancel();
    state.animation = details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: EASING });
    state.animation.onfinish = () => onFinish(details, state, false);
    state.animation.oncancel = () => (state.isClosing = false);
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary) return;

    const details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.closest('.accordion')) return;
    if (!details.querySelector('.accordion__content')) return;

    if (prefersReducedMotion()) return;

    event.preventDefault();
    details.style.overflow = 'hidden';

    const state = getState(details);
    if (state.isClosing || !details.open) {
      summary.setAttribute('aria-expanded', 'true');
      open(details, state);
    } else if (state.isExpanding || details.open) {
      summary.setAttribute('aria-expanded', 'false');
      close(details, summary, state);
    }
  });
})();
